var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextualHelpMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_49313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5508 26.0254C14.7514 23.1137 17.1157 20.4726 18.6437 18.1023C20.1718 15.732 20.9359 13.6444 20.9359 11.8396C20.9359 9.00001 20.0274 6.67782 18.2106 4.873C16.3937 3.06819 14.1738 2.16578 11.5508 2.16578C8.92782 2.16578 6.7079 3.06819 4.89105 4.873C3.0742 6.67782 2.16578 9.00001 2.16578 11.8396C2.16578 13.6444 2.94787 15.732 4.51204 18.1023C6.07621 20.4726 8.42247 23.1137 11.5508 26.0254ZM11.5508 28.877C7.67648 25.5803 4.78276 22.5181 2.86966 19.6905C0.956552 16.863 0 14.246 0 11.8396C0 8.22996 1.1611 5.35429 3.48329 3.21257C5.80549 1.07086 8.49467 0 11.5508 0C14.607 0 17.2961 1.07086 19.6183 3.21257C21.9405 5.35429 23.1016 8.22996 23.1016 11.8396C23.1016 14.246 22.1451 16.863 20.232 19.6905C18.3189 22.5181 15.4252 25.5803 11.5508 28.877Z",
    fill: "#9E52FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3695 20.2142H12.9947V11.1711H10.3695V20.2142ZM11.5508 7.93762C11.9592 7.93762 12.3019 7.80653 12.579 7.54436C12.8561 7.28218 12.9947 6.94718 12.9947 6.53936C12.9947 6.13153 12.8561 5.78197 12.579 5.49067C12.3019 5.19936 11.9592 5.05371 11.5508 5.05371C11.1425 5.05371 10.7997 5.19936 10.5226 5.49067C10.2455 5.78197 10.107 6.13153 10.107 6.53936C10.107 6.94718 10.2455 7.28218 10.5226 7.54436C10.7997 7.80653 11.1425 7.93762 11.5508 7.93762Z",
    fill: "#9E52FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_49313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextualHelpMain);
export default __webpack_public_path__ + "static/media/contextual-help-main.f39d6da20e9d871766cb0ed1a6b1257f.svg";
export { ForwardRef as ReactComponent };